/**
 * Created by admin on 2018/11/12.
 */
import post from '../post/post-proxy'
import shitang from './shitang'
import statistics from './Statistics'

let common = {
  /**
   * ehome.inner.org.info.get获取机构信息（包括机构基础信息，机构的人员）
   * @author wanghongling
   * @param orgId
   * @returns {Promise}
   */
  orgInfoGet ({orgId}) {
    let params = {orgId}
    for (let i in params) {
      if (params.hasOwnProperty(i) && !params[i]) {
        delete params[i]
      }
    }
    return post('inner', 'ehome.inner.org.info.get', params)
  },
  /**
   * login
   * @author: zhzhy
   * @createDate: 2019/6/17
   * @param {loginName String pwd String}
   * @return {Object}
   */
  login: (loginName, pwd) => post('oauth', 'ehome.ac.login.get', {loginName, pwd}),
  /**
   * 获取当前人员所在体系列表
   * @author: zhzhy
   * @createDate: 2019/6/17
   * @param {loginName String pwd String}
   * @return {Object}
   */
  getOsys: () => post('outer', 'ehome.osys.self.list.get', {}),
  /**
   * 获取指定体系下的组织列表
   * @author: zhzhy
   * @createDate: 2019/6/17
   * @param {loginName String pwd String}
   * @return {Object}
   */
  getOrgList: sysId => post('outer', 'ehome.osys.org.self.list.get', {sysId}),
  /**
   * 获取orgId下的部门列表
   * @author: zhzhy
   * @createDate: 2019/6/17
   * @param {loginName String pwd String}
   * @return {Object}
   */
  getDeptList: orgId => post('outer', 'ehome.org.dept.list.get', {orgId}),
  /**
   * 获取当前人员信息
   * @author: zhzhy
   * @createDate: 2019/6/17
   * @param {loginName String pwd String}
   * @return {Object}
   */
  getUserInfo: () => post('outer', 'ehome.user.get', {}),
  /**
   * @Description:获取体系人员基本信息
   * @param sysId
   * @param userId
   * @author wanghongling
   * @createDate 2019/12/23
  */
  osysMemberInfoGet ({sysId, userId}) {
    let params = {
      sysId
    }
    if (userId) {
      params.userId = userId
    }
    return post('outer', 'ehome.osys.member.base.get', params)
  },
  /**
   * ehome.metadata.district.list.get 获取字典
   * @param fuJiMxBh
   * @param zhiDianBh
   */
  ziDianMXListGet: ({fuJiMxBh, zhiDianBh}) => {
    let params = {
      zhiDianBh: zhiDianBh
    }
    if (fuJiMxBh) {
      params.fuJiMxBh = fuJiMxBh
    }
    return post('swagger', '/yongtai/shengtai/zhidianmx/list/get', params)
  },
  /**
   * 获取各食堂异常总数
   * @param deptName
   * @param orgId
   * @returns {Promise}
   */
  exceptionCountListGet: ({orgId, deptName}) => {
    let params = {
      orgId: orgId
    }
    if (deptName) {
      params.deptName = deptName
    }
    return post('swaggerSB', '/ygst/exception/count/list/get', params)
  },
  /**
   * 获取最新异常信息
   * @param orgId
   * @param page
   * @param pageSize
   * @returns {Promise}
   */
  exceptionNewListGet: ({orgId, page, pageSize}) => {
    let params = {
      orgId: orgId,
      page: page,
      pageSize: pageSize
    }
    return post('swaggerSB', '/ygst/exception/new/list/get', params)
  },
  /**
   * 获取健康证过期人员列表
   * @param orgId
   * @returns {Promise}
   */
  healthExpiryListGet: ({orgId}) => post('swagger', '/ygst/pc/health/expiry/list/get', {orgId}),
  /**
   * 获取承包商公示列表
   * @param orgId
   * @returns {Promise}
   */
  licenseListGet: ({orgId}) => post('swagger', '/ygst/pc/license/list/get', {orgId}),
  /**
   * 获取许可证信息(ndj)
   * @param orgId
   * @returns {Promise}
   */
  licenseInfoGet: ({orgId}) => post('swagger', '/ygst/pc/license/info/get', {orgId}),
  /**
   * 获取责任险信息(ndj)
   * @param orgId
   * @returns {Promise}
   */
  insuranceInfoGet: ({orgId}) => post('swagger', '/ygst/pc/insurance/list/get', {orgId}),
  /**
   * 获取营业执照信息(wzp)
   * @param orgId
   * @returns {Promise}
   */
  businesslicenseGet: ({orgId}) => post('swagger', '/ygst/pc/businesslicense/detail/get', {orgId}),
  /**
   * 获取各食堂当日耗电量
   * @param orgId
   * @returns {Promise}
   */
  electricTodayGet: ({orgId}) => post('swaggerSB', '/ygst/device/electric/today/get', {orgId}),
  /**
   * 获取各食堂当日耗水量
   * @param orgId
   * @returns {Promise}
   */
  waterTodayGet: ({orgId}) => post('swaggerSB', '/ygst/device/water/today/get', {orgId}),
  /**
   * 统计各类别的商家数量
   * @author: whl
   * @param orgId
   * @createDate: 2019/8/12
   */
  FoodShopTypeCountGet({orgId}) { // 必填项
    return post('swagger', '/ygst/peripheral/food/shop/type/count/get', {orgId})
  },
  /**
   * 根据商家类别获取周边商家信息
   * @author: whl
   * @param type {string} 商家类别
   * @param orgId {string} 组织机构
   * @createDate: 2019/8/12
   */
  peripheralFoodShopTypeGet({type, orgId}) {
    let params = {type, orgId} // 必填项
    return post('swagger', '/ygst/peripheral/food/shop/type/get', params)
  },
  /**
   * 获取巡查记录列表
   * @author: whl
   * @param beginTime
   * @param endTime
   * @param orgId
   * @param page
   * @param pageSize
   * @param peripheralId
   * @param peripheralName
   * @createDate: 2019/9/9
   */
  patrolRecordListGet({beginTime, endTime, orgId, page, pageSize, peripheralId, peripheralName}) {
    let params = {orgId, page, pageSize} // 必填项
    if (beginTime) {
      params.beginTime = beginTime
    }
    if (endTime) {
      params.endTime = endTime
    }
    if (peripheralId) {
      params.peripheralId = peripheralId
    }
    if (peripheralName) {
      params.peripheralName = peripheralName
    }
    return post('swagger', '/ygst/patrol/record/list/get', params)
  },
  /**
   * 按照食堂分类获取获取今日异常处置未处置统计信息
   * @author: whl
   * @param orgId
   * @createDate: 2019/9/12
   */
  todayTypeHandleInfoGet({orgId}) {
    let params = {orgId} // 必填项
    return post('swaggerSB', '/ygst/exception/today/type/handle/info/get', params)
  },
  /**
   * @Description:获取食堂列表(ID和名称)(wzp)
   * @author wanghongling
   * @param orgId
   * @createDate 2019/12/3
  */
  deptBaseListGet({orgId}) {
    let params = {orgId} // 必填项
    return post('swagger', '/ygst/dept/base/list/get', params)
  },
  /**
   * @Description:获取视图权限(wzp)
   * @param orgId组织id
   * @author wanghongling
   * @createDate 2019/12/11
   */
  schoolviewGet({orgId}) {
    let params = {orgId} // 必填项
    return post('swagger', '/ygst/schoolview/get', params)
  },
  /**
   * @Description:大屏显示-整体视图-体温异常人员（wzp）
   * @param orgId组织id
   * @author wanghongling
   * @createDate 2019/12/11
   */
  exceptionTemperatureGet({orgId}) {
    let params = {orgId} // 必填项
    return post('swagger', '/ygst/pc/health/wholeview/exception/temperature', params)
  }
}
let request = Object.assign(common, shitang, statistics)
export default request



// WEBPACK FOOTER //
// ./src/request/index.js